import { render, staticRenderFns } from "./PantallaPerfilamiento.vue?vue&type=template&id=55975b74"
import script from "./PantallaPerfilamiento.vue?vue&type=script&lang=js"
export * from "./PantallaPerfilamiento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports